var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 13h4v19h-4zM26 13h4v19h-4z"}));
}

Pause.defaultProps = {"width":"45","height":"45","viewBox":"0 0 45 45"};

module.exports = Pause;

Pause.default = Pause;
